import Projects from '@/views/modules/project_management/pages/Projects.vue'
import ProjectsNewEdit from '@/views/modules/project_management/forms/ProjectsNewEdit.vue'
import ProjPlaner from '@/views/modules/project_management/pages/Planer.vue'
import ProjSudionici from '@/views/modules/project_management/pages/Sudionici.vue'
import FolderBlockProject from '@/views/modules/project_management/pages/FolderBlock.vue'
import PostaProject from '@/views/modules/project_management/pages/Posta.vue'
import MessengerProject from '@/views/modules/project_management/pages/Messenger.vue'
import CalendarProject from '@/views/modules/project_management/pages/CalendarProject.vue'
import EnterNewEvent from '@/views/modules/general/forms/EnterNewEvent.vue'
import NotPartProj from '@/views/modules/project_management/pages/NotPart.vue'



import { store } from "@/vuex/store.js"
import permissioner from '../../services/permissioner'
import projects from "@/apiCallers/promise_handler_db/projects"



const regulateBeforeEnter = async (to, from, next) => {
    // Get user info if it is on reload
    console.log(to.params.uid)
    await permissioner.checkUserInfo();
    let is_available = await getSingleUserPermissions(to.params.uid);
    // Checking if user has the right access to the application view
    if (is_available) {
      next()
    } else {
      // Did  not satisfy the requirements for accessing the view
      next({ name: 'NotPartOfProject' })
    }
  }


var project_routes = [
    // PROJECT START
    {
        path: '/projects',
        name: 'Projects',
        component: Projects,
        meta: { requiresAuth: true }
    },
    {
        path: '/projects/new',
        name: 'ProjectsNew',
        component: ProjectsNewEdit,
        meta: { requiresAuth: true },
        beforeEnter: async (to, from, next) => {
            // Get user info if it is on reload
            await permissioner.checkUserInfo();
            // Checking if user has the right access to the application view
            if (await permissioner.check_application_permission("application.project.create")) {
                next()
            } else {
                // Did  not satisfy the requirements for accessing the view
                next({ name: 'NoPermission' })
            }
        }
    },
    {
        path: '/project-not-part',
        name: 'NotPartOfProject',
        component: NotPartProj,
        meta: { requiresAuth: true }
      },
    {
        path: '/projects/:uid/edit',
        name: 'ProjectEdit',
        component: ProjectsNewEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/projects/:uid',
        name: 'ProjectPlaner',
        component: ProjPlaner,
        meta: { requiresAuth: true },
        beforeEnter: regulateBeforeEnter
    },
    {
        path: '/projects/:uid/participants',
        name: 'ProjSudionici',
        component: ProjSudionici,
        meta: { requiresAuth: true },
        beforeEnter: regulateBeforeEnter
    },
    {
        path: '/projects/:uid/radni',
        name: 'ProjectRadni',
        component: FolderBlockProject,
        meta: { requiresAuth: true },
        beforeEnter: regulateBeforeEnter
    },
    {
        path: '/projects/:uid/popratni',
        name: 'ProjectPopratni',
        component: FolderBlockProject,
        meta: { requiresAuth: true },
        beforeEnter: regulateBeforeEnter
    },
    {
        path: '/projects/:uid/komunikacija',
        name: 'ProjectUlaznaPosta',
        component: PostaProject,
        meta: { requiresAuth: true },
        beforeEnter: regulateBeforeEnter
    },
    {
        path: '/projects/:uid/messenger',
        name: 'MessengerProject',
        component: MessengerProject,
        meta: { requiresAuth: true },
        beforeEnter: regulateBeforeEnter
    },
    {
        path: '/projects/:uid/kalendar',
        name: 'KalendarProject',
        component: CalendarProject,
        meta: { requiresAuth: true },
        beforeEnter: regulateBeforeEnter
    },
    {
        path: '/projects/:uid/kalendar/novi-dogadaj',
        name: 'EnterNewProjectEvent',
        component: EnterNewEvent,
        meta: { requiresAuth: true }
    },
    {
        path: '/projects/:uid/kalendar/edit',
        name: 'EditProjectEvent',
        component: EnterNewEvent,
        meta: { requiresAuth: true }
    },
    {
        path: '/finished-projects',
        name: 'FinishedProjects',
        component: Projects,
        meta: { requiresAuth: true }
    },
    {
        path: '/finished-projects/new',
        name: 'ProjectsNew',
        component: ProjectsNewEdit,
        meta: { requiresAuth: true },
        beforeEnter: async (to, from, next) => {
            // Get user info if it is on reload
            await permissioner.checkUserInfo();
            // Checking if user has the right access to the application view
            if (await permissioner.check_application_permission("application.project.create")) {
                next()
            } else {
                // Did  not satisfy the requirements for accessing the view
                next({ name: 'NotPartOfProject' })
            }
        }
    },
    {
        path: '/finished-projects/:uid/edit',
        name: 'ProjectEdit',
        component: ProjectsNewEdit,
        meta: { requiresAuth: true }
    },
    {
        path: '/finished-projects/:uid',
        name: 'ProjectPlaner',
        component: ProjPlaner,
        meta: { requiresAuth: true },
        beforeEnter: regulateBeforeEnter
    },
    {
        path: '/finished-projects/:uid/participants',
        name: 'ProjSudionici',
        component: ProjSudionici,
        meta: { requiresAuth: true },
        beforeEnter: regulateBeforeEnter
    },
    {
        path: '/finished-projects/:uid/radni',
        name: 'ProjectRadni',
        component: FolderBlockProject,
        meta: { requiresAuth: true },
        beforeEnter: regulateBeforeEnter
    },
    {
        path: '/finished-projects/:uid/popratni',
        name: 'ProjectPopratni',
        component: FolderBlockProject,
        meta: { requiresAuth: true },
        beforeEnter: regulateBeforeEnter
    },
    {
        path: '/finished-projects/:uid/komunikacija',
        name: 'ProjectUlaznaPosta',
        component: PostaProject,
        meta: { requiresAuth: true }
    },
    {
        path: '/finished-projects/:uid/messenger',
        name: 'MessengerProject',
        component: MessengerProject,
        meta: { requiresAuth: true }
    },
    {
        path: '/finished-projects/:uid/kalendar',
        name: 'KalendarProject',
        component: CalendarProject,
        meta: { requiresAuth: true }
    },
    {
        path: '/finished-projects/:uid/kalendar/novi-dogadaj',
        name: 'EnterNewProjectEvent',
        component: EnterNewEvent,
        meta: { requiresAuth: true }
    },
    {
        path: '/finished-projects/:uid/kalendar/edit',
        name: 'EditProjectEvent',
        component: EnterNewEvent,
        meta: { requiresAuth: true }
    },
    // PROJECT END
]


var getSingleUserPermissions = async function (proj_id) {
    // 1. Check if state is empty or case id is same as mapped
    // if empty get data
    if (store.state.user_project_permissions == undefined) {
        await projects.getUserProjectPermission(proj_id, store.state.logged_in_user.uid).then((resp) => {
            permissioner.save_project_permission(proj_id, resp.data);
        })
    }
    else if (store.state.user_project_permissions.proj_id != proj_id) {
        await projects.getUserProjectPermission(proj_id, store.state.logged_in_user.uid).then((resp) => {
            permissioner.save_project_permission(proj_id, resp.data);
        })
    }
    // 2. Check the value when we have data
    // if not return true
    if (store.state.user_project_permissions.available_permissions.length > 0 || store.state.logged_in_user.user_role.id == 1)
        return true
    // if empty return false
    else return false;

}
const getProjData = async function (proj_id) {
    // check for stored case data
    console.log("Checking for data", store.state.current_selected_proj,proj_id)
    if (store.state.current_selected_proj == undefined || store.state.current_selected_proj == null) {
        console.log("The value of the case in store is undefined.", store.state.current_selected_proj)
        await projects.getSingle(proj_id, store.state.logged_in_user.uid).then(async (response) => {
            store.state.current_selected_proj  = response.data

        });
    } else if (store.state.current_selected_proj.group_url != proj_id) {
        console.log("The value of the case in store is different case.", proj_id, store.state.current_selected_proj)
        await projects.getSingle(proj_id,store.state.logged_in_user.uid).then(async (response) => {
            store.state.current_selected_proj  = response.data

        });
    }
    console.log("Got new data.", store.state.current_selected_proj)
      // return the case data if propperly selected
  return store.state.current_selected_proj;
}
const clearProjectData = async function () {
    store.state.current_selected_proj = undefined
  }

export { project_routes, getProjData, clearProjectData }